import script from "./MedicationProductionFreq.vue?vue&type=script&setup=true&lang=ts"
export * from "./MedicationProductionFreq.vue?vue&type=script&setup=true&lang=ts"

import "./MedicationProductionFreq.vue?vue&type=style&index=0&id=1ab9309a&lang=scss"

const __exports__ = script;

export default __exports__